import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ContractBase} from "../../../company/x-models/contract-base";
import {NgClass} from "@angular/common";
import {DayKeyPipe} from "../../../../_shared/time/day-key.pipe";

@Component({
  selector: 'app-contract-information',
  imports: [
    DayKeyPipe,
    NgClass
  ],
  templateUrl: './contract-information.component.html',
  styleUrl: './contract-information.component.scss'
})
export class ContractInformationComponent {
  @Input() contract!: ContractBase;
  @Output() edit = new EventEmitter<ContractBase>();
  @Input() canEdit: boolean = false;
  /** Optional status pill (e.g. "Geplant"/"Beendet") + its Tailwind colour classes. */
  @Input() badge?: string;
  @Input() badgeClass: string = "bg-gray-100 text-gray-600";

  e() {
    this.edit.emit(this.contract)
  }
}
